<template>
  <div class="course">
    <img alt="image" id="bannerTeam" src="../assets/course.png" class="hezhao">
    <calender :calenders="calendars" id="calender" :isFixed="isFixd" @changeDate="changeDate"></calender>
    <content-box>
      <p class="course-title">
        {{course.title}}
        <span class="course-year">{{course.year}}</span>
      </p>
      <p class="course-disc" v-html="course.description"></p>
      <p class="course-table-title">Course materials</p>
      <table-card :tableData="course.tableData"></table-card>
    </content-box>
    <div class="instructor-box">
      <img src="../assets/course/introductors.png" alt="">
      <div class="course-content">
        <instructor v-for="(item, index) in course.instructors" :key="item.name" :item="item" :class="['course-instru', {'no-margin': index === 2}]"></instructor>
      </div>
    </div>
    <!-- <p class="sub-title">Practice</p> -->
    <!-- <div class="machine-btn"><a href="http://olddriver.website/virtualmachine/" target="_blank" class="virtual-box">CentOS-7 Linux Virtual Machine</a></div> -->
    <p class="sub-title margin-top4">Reference books</p>
    <div class="reference-content">
      <reference-card :item="course.referenceBox[0]" class="card margin-right1"></reference-card>
      <reference-card :item="course.referenceBox[1]" :tight="true" class="card"></reference-card>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import ContentBox from '@/components/ContentBox.vue'
import Calender from '@/components/Calender.vue'
import TableCard from '@/components/course/TableCard.vue'
import Instructor from '@/components/course/Instructor.vue'
import ReferenceCard from '@/components/course/ReferenceCard.vue'
import courses from '../data/courses'

export default {
  name: 'course',
  components: {
    ContentBox,
    Calender,
    TableCard,
    Instructor,
    ReferenceCard
  },
  data () {
    return {
      index: 0,
      isFixd: false,
    }
  },
  computed: {
    calendars() {
      let obj = []
      courses.forEach(item => {
        obj.push(item.year)
      })
      return obj
    },
    course() {
      return courses[this.index]
    }
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll, false)
  },
  mounted () {
    window.scrollTo(0, 0)
    window.addEventListener('scroll', this.handleScroll, false)
    // console.log(this.calendars)
    // console.log(this.course)
  },
  methods: {
    changeDate (val, idx) {
      this.index = idx
    },
    handleScroll () {
      const heightTop = document.documentElement.scrollTop || document.body.scrollTop
      let heighImg = document.getElementById('bannerTeam').clientHeight
      if (heightTop > heighImg) {
        this.isFixd = true
      } else {
        this.isFixd = false
      }
    }
  }
}
</script>

<style scoped lang="less">
  .course {
    width: 100%;
    font-size: 0;
    margin-bottom: 4.16rem;

    .hezhao {
      width: 100%;
    }

    .course-title {
      font-size: 3.3rem;
      font-weight: 600;
      color: #000;
      margin: 4.16rem 0 0.83rem;
      text-align: center;

      .course-year {
        color: #080DBF;
        margin-left: 0.83rem;
      }
    }

    .course-disc {
      font-size: 1.5rem;
      color: #717171;
      text-align: center;
    }

    .course-table-title {
      font-size: 3rem;
      color: #484848;
      text-align: center;
      margin: 4.1rem 0 2.5rem;
    }

    .instructor-box {
      width: 100%;
      position: relative;

      img {
        width: 100%;
      }

      .course-content {
        background: transparent;
        width: 100%;
        max-width: 1200px;
        min-width: 900px;
        overflow: hidden;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        .course-instru {
          width: 32%;
          display: inline-block;
          margin-right: 1%;
        }

        .no-margin {
          margin-right: 0;
        }
      }
    }

    .sub-title {
      font-size: 3rem;
      font-weight: 600;
      color: #000;
      margin: 8.4rem 0 2.5rem;
      text-align: center;
    }

    .machine-btn {
      background: #FFD500;
      box-shadow: 0 4px 15px 0 #FFD500;
      border-radius: 40px;
      font-size: 2.5rem;
      color: #3E3E3E;
      width: 46rem;
      height: 6.8rem;
      line-height: 6.8rem;
      margin: 0 auto;
    }

    .margin-top4 {
      margin-top: 4.16rem;
    }

    .margin-right1 {
      margin-right: 1.6rem;
    }

    .reference-content {
      background: #fff;
      width: 100%;
      margin: 0 auto;
      max-width: 1200px;
      min-width: 900px;
      overflow: hidden;
      padding: 15px 0;

      .card {
        width: 48%;
        display: inline-block;
      }
    }

    .virtual-box {
      text-decoration: none; color: white
    }
  }
  /deep/ .calender .calender-node {
    width: 10%;
  }
</style>
